import React from 'react';
import { motion } from 'framer-motion';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/components/ui/accordion';
import { KEMPO_HISTORY, BELT_RANKS } from '../../lib/constants';

const History = () => (
  <section id="history" className="relative py-16 sm:py-20" data-testid="history-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-1 lg:grid-cols-12 gap-10">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6 }}
        className="lg:col-span-6"
      >
        <span className="font-display uppercase tracking-[0.22em] text-[11px] text-[color:var(--neon-red)]">
          History of Kempo
        </span>
        <h2 className="mt-3 font-display text-3xl sm:text-4xl text-white tracking-tight">
          From ancient China to Colorado Springs.
        </h2>
        <p className="mt-4 text-white/75 leading-relaxed">
          Kempo — the “Way of the Fist” — is one of the oldest martial traditions
          on earth. We carry that lineage forward in a modern, family-safe karate school.
        </p>

        <Accordion type="single" collapsible defaultValue="era-0" className="mt-6">
          {KEMPO_HISTORY.map((h, i) => (
            <AccordionItem
              key={h.era}
              value={`era-${i}`}
              className="border-b border-white/10"
              data-testid={`history-accordion-${i}`}
            >
              <AccordionTrigger className="text-white font-display uppercase tracking-[0.14em] text-sm hover:no-underline">
                {h.era}
              </AccordionTrigger>
              <AccordionContent className="text-white/75 text-sm leading-relaxed">
                {h.body}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="lg:col-span-6"
      >
        <div className="panel rounded-2xl p-6">
          <div className="flex items-center justify-between">
            <span className="font-display uppercase tracking-[0.18em] text-[11px] text-white/70">
              Belt Ranks
            </span>
            <span className="font-mono-ui text-[11px] text-[color:var(--neon-cyan)]">
              White → Black → Dan
            </span>
          </div>
          <div className="mt-5 space-y-2">
            {BELT_RANKS.map((b) => (
              <div
                key={b.name}
                className="flex items-center gap-3 px-3 py-2 rounded-lg border border-white/8 bg-white/[0.02] hover:bg-white/[0.05] transition-colors"
                data-testid={`belt-${b.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <span
                  className="inline-block h-3.5 w-7 rounded-sm border border-white/15"
                  style={{ background: b.color }}
                />
                <span className="font-display text-white text-sm w-28">{b.name}</span>
                <span className="text-xs text-white/65 flex-1">{b.desc}</span>
              </div>
            ))}
          </div>
          <p className="mt-5 text-xs text-white/55">
            Belt progression is earned through consistent training, technique testing,
            and demonstrated character.
          </p>
        </div>
      </motion.div>
    </div>
  </section>
);

export default History;
